import React, {useEffect, useRef, useState} from "react";
import DevicesComponent from "./Devices";
import BondNode from "./Node";
import "./BondTree.css";
import Row from "react-bootstrap/Row";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faRotateRight} from "@fortawesome/free-solid-svg-icons/faRotateRight";

const autoReloadTime = 1000;

function BondTree({bond}) {
    const [autoReload, setAutoReload] = useState(false);
    const [reloadTimestamp, setReloadTimestamp] = useState(null);
    const reloadIntervalRef = useRef(0);

    useEffect(() => {
        if (autoReload)
            reloadIntervalRef.current = setInterval(() => reload(), autoReloadTime);
        else clearInterval(reloadIntervalRef.current);
        return () => clearInterval(reloadIntervalRef.current);
    }, [autoReload]);

    function reload() {
        setReloadTimestamp(Date.now());
    }

    function customAttrComponent(attr, value) {
        switch (attr) {
            case "devices":
                return (
                    <DevicesComponent
                        key={attr}
                        parentU={value["_"]}
                        bond={bond}
                        path={`/${attr}/`}
                        label={attr}
                    />
                );
            default:
                return null;
        }
    }

    return (
        <Row className="bondTree">
            <Row className="w-25 pb-3">
                <ButtonGroup className={"bondTreeButtonGroup"}>
                    <Button variant="outline-primary"
                            className=""
                            onClick={reload}
                            disabled={autoReload ? "disabled" : ""}>Reload
                    </Button>
                    <Button className={"bondTreeAutoReloadButton"}
                        variant={autoReload ? "success" : "outline-primary"}
                            onClick={() => setAutoReload(!autoReload)}>
                        <FontAwesomeIcon icon={faRotateRight} className={autoReload ? "fa-spin" : ""}/>
                    </Button>
                </ButtonGroup>
            </Row>

            <Row className="bondTreeBody">
                <BondNode
                    bond={bond}
                    path="/"
                    className={"bondNodeRoot"}
                    label={bond.id}
                    customAttrComponent={customAttrComponent}
                    extraComponents={[
                        <BondNode bond={bond} path="/debug/" label="debug" key="debug" customVariant={"secondary"}/>,
                    ]}
                    isOpen={true}
                    reloadTimestamp={reloadTimestamp}
                />
            </Row>
        </Row>
    );
}

export default BondTree;
